import request from '@/utils/request'
import Storage from '@/utils/storage'
import md5 from 'js-md5'

/**
 * 登录
 * @param params
 * @returns {*}
 */
export function login(params) {
  if(!params.isold){
    params.password = md5(params.password)
  }
  return request({
    url: '/login',
    method: 'post',
    loading: false,
    data: params
  })
}

/**
 * 退出账户
 * @returns {*}
 */
export function logout() {
  return request({
    url: `/logout`,
    method: 'post',
    loading: false,
  })
}

/**
 * 获取用户角色权限
 * @param role_id
 * @returns {*}
 */
export function getUserRolesPermissions(role_id) {
  return request({
    url: `admin/systems/roles/${role_id}/checked`,
    method: 'get'
  })
}

/**
 * 获取短信验证码
 * @param params
 * @returns {*}
 */
export function phoneCode(params) {
  return request({
    // url: 'admin/systems/admin-users/security/send',
    url: 'security/send',
    method: 'get',
    loading: false,
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js